module.exports = __webpack_public_path__ + "img/First_image.c4dc87bd.svg";